import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { urlPath } from "../util/url.js";
import { stripEmptyValues } from "../util/object.js";
import { isCaptchaError, isLoginCaptchaError, isNotUniqueGuestAccount, isValidationError } from "../util/ams.js";
import { newLoginInvalidError, newValidationFailedError, newResetPasswordTokenInvalidError, newCaptchaRequiredError, newNotUniqueGuestAccount } from "../errors/errors.js";
export var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse;
  return {
    login: function () {
      var _login = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var username, password, captchaToken, isMiniFlexLogin, language;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              username = _ref2.username, password = _ref2.password, captchaToken = _ref2.captchaToken, isMiniFlexLogin = _ref2.isMiniFlexLogin, language = _ref2.language;
              _context.prev = 1;
              _context.next = 4;
              return amsResponse.getRawBody({
                method: "POST",
                path: "login",
                contentType: amsResponse.contentTypes.form,
                body: {
                  username: username && username.trim(),
                  password: password,
                  rememberMe: true,
                  captcha: captchaToken,
                  isMiniPortalLogin: isMiniFlexLogin,
                  language: language
                }
              });
            case 4:
              return _context.abrupt("return", _context.sent);
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              if (!isLoginCaptchaError(_context.t0)) {
                _context.next = 11;
                break;
              }
              throw newCaptchaRequiredError(_context.t0);
            case 11:
              if (!(_context.t0.status === 403)) {
                _context.next = 13;
                break;
              }
              throw newLoginInvalidError(_context.t0);
            case 13:
              throw _context.t0;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 7]]);
      }));
      function login(_x) {
        return _login.apply(this, arguments);
      }
      return login;
    }(),
    loginWithToken: function () {
      var _loginWithToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var regToken;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              regToken = _ref3.regToken;
              return _context2.abrupt("return", amsResponse.getRawBody({
                method: "POST",
                path: "login",
                contentType: amsResponse.contentTypes.form,
                body: {
                  mailToken: regToken,
                  rememberMe: true
                }
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function loginWithToken(_x2) {
        return _loginWithToken.apply(this, arguments);
      }
      return loginWithToken;
    }(),
    logout: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return amsResponse.getRawBody({
                method: "POST",
                path: "logout"
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    getProfile: function () {
      var _getProfile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return amsResponse.getRawBody({
                method: "GET",
                path: "user/customer"
              });
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              if (!(_context4.t0.status === 401)) {
                _context4.next = 10;
                break;
              }
              return _context4.abrupt("return", undefined);
            case 10:
              throw _context4.t0;
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 6]]);
      }));
      function getProfile() {
        return _getProfile.apply(this, arguments);
      }
      return getProfile;
    }(),
    getContactPeople: function () {
      var _getContactPeople = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var contactPeople;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return amsResponse.getData({
                method: "GET",
                path: "v1.1/user/contractcontact"
              });
            case 2:
              contactPeople = _context5.sent;
              return _context5.abrupt("return", contactPeople || []);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function getContactPeople() {
        return _getContactPeople.apply(this, arguments);
      }
      return getContactPeople;
    }(),
    getAuthorizedUsers: function () {
      var _getAuthorizedUsers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var authorizedUsers;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: "v1.3/customerRel/authorizedcustomers"
              });
            case 3:
              authorizedUsers = _context6.sent;
              return _context6.abrupt("return", authorizedUsers || []);
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);
              if (!(_context6.t0.status === 401)) {
                _context6.next = 13;
                break;
              }
              return _context6.abrupt("return", []);
            case 13:
              throw _context6.t0;
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 7]]);
      }));
      function getAuthorizedUsers() {
        return _getAuthorizedUsers.apply(this, arguments);
      }
      return getAuthorizedUsers;
    }(),
    switchToUser: function () {
      var _switchToUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref4) {
        var id;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              id = _ref4.id;
              return _context7.abrupt("return", amsResponse.getData({
                method: "POST",
                path: "v1.3/customerRel/changecustomer",
                contentType: amsResponse.contentTypes.json,
                body: {
                  id: id
                }
              }));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function switchToUser(_x3) {
        return _switchToUser.apply(this, arguments);
      }
      return switchToUser;
    }(),
    setDeviantBillingAddress: function () {
      var _setDeviantBillingAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(deviantBillingAddress) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.2/user/deviantBillingAddress",
                contentType: amsResponse.contentTypes.json,
                body: deviantBillingAddress
              });
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function setDeviantBillingAddress(_x4) {
        return _setDeviantBillingAddress.apply(this, arguments);
      }
      return setDeviantBillingAddress;
    }(),
    setEBillingMailAddress: function () {
      var _setEBillingMailAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref5) {
        var eBillingMailAddress;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              eBillingMailAddress = _ref5.eBillingMailAddress;
              return _context9.abrupt("return", amsResponse.getData({
                method: "POST",
                path: "v1.2/user/eBilling",
                contentType: amsResponse.contentTypes.json,
                body: {
                  eBillingMailAddress: eBillingMailAddress
                }
              }));
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function setEBillingMailAddress(_x5) {
        return _setEBillingMailAddress.apply(this, arguments);
      }
      return setEBillingMailAddress;
    }(),
    deleteEBillingMailAddress: function () {
      var _deleteEBillingMailAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", amsResponse.getData({
                method: "DELETE",
                path: "v1.2/user/eBilling"
              }));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function deleteEBillingMailAddress() {
        return _deleteEBillingMailAddress.apply(this, arguments);
      }
      return deleteEBillingMailAddress;
    }(),
    getDefaultBankAccount: function () {
      var _getDefaultBankAccount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var defaultBankAccount;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return amsResponse.getData({
                method: "GET",
                path: "v1.2/user/defaultBankAccount"
              });
            case 2:
              defaultBankAccount = _context11.sent;
              return _context11.abrupt("return", defaultBankAccount && Object.keys(defaultBankAccount).length > 0 ? defaultBankAccount : undefined);
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      function getDefaultBankAccount() {
        return _getDefaultBankAccount.apply(this, arguments);
      }
      return getDefaultBankAccount;
    }(),
    getCreditCards: function () {
      var _getCreditCards = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var data;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: "v1.2/user/payment/get/creditcards"
              });
            case 3:
              data = _context12.sent;
              return _context12.abrupt("return", data || []);
            case 7:
              _context12.prev = 7;
              _context12.t0 = _context12["catch"](0);
              if (!(_context12.t0.status === 401)) {
                _context12.next = 11;
                break;
              }
              return _context12.abrupt("return", []);
            case 11:
              throw _context12.t0;
            case 12:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[0, 7]]);
      }));
      function getCreditCards() {
        return _getCreditCards.apply(this, arguments);
      }
      return getCreditCards;
    }(),
    getCaptchaSiteKey: function () {
      var _getCaptchaSiteKey = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var data;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return amsResponse.getRawBody({
                method: "GET",
                path: "user/captchaSiteKey"
              });
            case 2:
              data = _context13.sent;
              return _context13.abrupt("return", data === null || data === void 0 ? void 0 : data.siteKey);
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      function getCaptchaSiteKey() {
        return _getCaptchaSiteKey.apply(this, arguments);
      }
      return getCaptchaSiteKey;
    }(),
    deleteCreditCard: function () {
      var _deleteCreditCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref6) {
        var creditCardId;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              creditCardId = _ref6.creditCardId;
              _context14.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.2/user/payment/delete/creditcard",
                contentType: amsResponse.contentTypes.json,
                body: {
                  id: creditCardId
                }
              });
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      function deleteCreditCard(_x6) {
        return _deleteCreditCard.apply(this, arguments);
      }
      return deleteCreditCard;
    }(),
    changePassword: function () {
      var _changePassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(passwordData) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.3/user/changePassword",
                contentType: amsResponse.contentTypes.json,
                body: passwordData
              });
            case 3:
              _context15.next = 14;
              break;
            case 5:
              _context15.prev = 5;
              _context15.t0 = _context15["catch"](0);
              if (!isCaptchaError(_context15.t0)) {
                _context15.next = 9;
                break;
              }
              throw newCaptchaRequiredError(_context15.t0);
            case 9:
              if (!isValidationError(_context15.t0)) {
                _context15.next = 13;
                break;
              }
              throw newValidationFailedError(_context15.t0);
            case 13:
              throw _context15.t0;
            case 14:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[0, 5]]);
      }));
      function changePassword(_x7) {
        return _changePassword.apply(this, arguments);
      }
      return changePassword;
    }(),
    requestNewPassword: function () {
      var _requestNewPassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref7) {
        var login, contractType, captchaToken;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              login = _ref7.login, contractType = _ref7.contractType, captchaToken = _ref7.captchaToken;
              _context16.prev = 1;
              _context16.next = 4;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.2/user/requestNewPassword",
                contentType: amsResponse.contentTypes.json,
                body: {
                  login: login.trim(),
                  contractType: contractType,
                  captchaToken: captchaToken
                }
              });
            case 4:
              _context16.next = 11;
              break;
            case 6:
              _context16.prev = 6;
              _context16.t0 = _context16["catch"](1);
              if (!isCaptchaError(_context16.t0)) {
                _context16.next = 10;
                break;
              }
              throw newCaptchaRequiredError(_context16.t0);
            case 10:
              throw _context16.t0;
            case 11:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[1, 6]]);
      }));
      function requestNewPassword(_x8) {
        return _requestNewPassword.apply(this, arguments);
      }
      return requestNewPassword;
    }(),
    resetPassword: function () {
      var _resetPassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref8) {
        var token, username, password, passwordRepeat, validationError, title, displayMessage;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              token = _ref8.token, username = _ref8.username, password = _ref8.password, passwordRepeat = _ref8.passwordRepeat;
              _context17.prev = 1;
              _context17.next = 4;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.2/user/setNewPassword",
                contentType: amsResponse.contentTypes.json,
                body: {
                  token: token,
                  username: username,
                  password: password,
                  passwordRepeat: passwordRepeat
                }
              });
            case 4:
              _context17.next = 18;
              break;
            case 6:
              _context17.prev = 6;
              _context17.t0 = _context17["catch"](1);
              if (!isValidationError(_context17.t0)) {
                _context17.next = 17;
                break;
              }
              validationError = newValidationFailedError(_context17.t0);
              title = validationError.displayMessage;
              if (!validationError.errors.token) {
                _context17.next = 16;
                break;
              }
              displayMessage = validationError.errors.token;
              throw newResetPasswordTokenInvalidError({
                title: title,
                displayMessage: displayMessage
              });
            case 16:
              throw validationError;
            case 17:
              throw _context17.t0;
            case 18:
            case "end":
              return _context17.stop();
          }
        }, _callee17, null, [[1, 6]]);
      }));
      function resetPassword(_x9) {
        return _resetPassword.apply(this, arguments);
      }
      return resetPassword;
    }(),
    signUp: function () {
      var _signUp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(signUpData) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.3/user/register",
                contentType: amsResponse.contentTypes.json,
                body: signUpData
              });
            case 3:
              return _context18.abrupt("return", _context18.sent);
            case 6:
              _context18.prev = 6;
              _context18.t0 = _context18["catch"](0);
              if (!isCaptchaError(_context18.t0)) {
                _context18.next = 10;
                break;
              }
              throw newCaptchaRequiredError(_context18.t0);
            case 10:
              if (!isValidationError(_context18.t0)) {
                _context18.next = 12;
                break;
              }
              throw newValidationFailedError(_context18.t0);
            case 12:
              throw _context18.t0;
            case 13:
            case "end":
              return _context18.stop();
          }
        }, _callee18, null, [[0, 6]]);
      }));
      function signUp(_x10) {
        return _signUp.apply(this, arguments);
      }
      return signUp;
    }(),
    signUpAsGuest: function () {
      var _signUpAsGuest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19(signUpData) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.3/user/registerAsGuest",
                contentType: amsResponse.contentTypes.json,
                body: signUpData
              });
            case 3:
              return _context19.abrupt("return", _context19.sent);
            case 6:
              _context19.prev = 6;
              _context19.t0 = _context19["catch"](0);
              if (!isNotUniqueGuestAccount(_context19.t0)) {
                _context19.next = 10;
                break;
              }
              throw newNotUniqueGuestAccount(_context19.t0);
            case 10:
              if (!isCaptchaError(_context19.t0)) {
                _context19.next = 12;
                break;
              }
              throw newCaptchaRequiredError(_context19.t0);
            case 12:
              if (!isValidationError(_context19.t0)) {
                _context19.next = 14;
                break;
              }
              throw newValidationFailedError(_context19.t0);
            case 14:
              throw _context19.t0;
            case 15:
            case "end":
              return _context19.stop();
          }
        }, _callee19, null, [[0, 6]]);
      }));
      function signUpAsGuest(_x11) {
        return _signUpAsGuest.apply(this, arguments);
      }
      return signUpAsGuest;
    }(),
    requestSignUp: function () {
      var _requestSignUp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20(signUpData) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.2/user/applicantRegistration",
                contentType: amsResponse.contentTypes.json,
                body: signUpData
              });
            case 3:
              _context20.next = 10;
              break;
            case 5:
              _context20.prev = 5;
              _context20.t0 = _context20["catch"](0);
              if (!isCaptchaError(_context20.t0)) {
                _context20.next = 9;
                break;
              }
              throw newCaptchaRequiredError(_context20.t0);
            case 9:
              throw _context20.t0;
            case 10:
            case "end":
              return _context20.stop();
          }
        }, _callee20, null, [[0, 5]]);
      }));
      function requestSignUp(_x12) {
        return _requestSignUp.apply(this, arguments);
      }
      return requestSignUp;
    }(),
    activateAccount: function () {
      var _activateAccount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref9) {
        var activationToken, rentContractToken, _yield$amsResponse$ge, regToken, rentContractId;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              activationToken = _ref9.activationToken, rentContractToken = _ref9.rentContractToken;
              _context21.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.2/user/activate",
                contentType: amsResponse.contentTypes.json,
                body: {
                  token: activationToken,
                  rentcontractid: rentContractToken
                }
              });
            case 3:
              _yield$amsResponse$ge = _context21.sent;
              regToken = _yield$amsResponse$ge.regToken;
              rentContractId = _yield$amsResponse$ge.rentContractId;
              return _context21.abrupt("return", {
                regToken: regToken,
                rentContractId: rentContractId ? Number(rentContractId) : undefined
              });
            case 7:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      function activateAccount(_x13) {
        return _activateAccount.apply(this, arguments);
      }
      return activateAccount;
    }(),
    extendRegistration: function () {
      var _extendRegistration = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee22(userData) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;
              _context22.next = 3;
              return amsResponse.getData({
                method: "POST",
                path: "v1.1/user/extendRegistration",
                contentType: amsResponse.contentTypes.json,
                body: stripEmptyValues(userData)
              });
            case 3:
              return _context22.abrupt("return", _context22.sent);
            case 6:
              _context22.prev = 6;
              _context22.t0 = _context22["catch"](0);
              if (!isValidationError(_context22.t0)) {
                _context22.next = 10;
                break;
              }
              throw newValidationFailedError(_context22.t0);
            case 10:
              throw _context22.t0;
            case 11:
            case "end":
              return _context22.stop();
          }
        }, _callee22, null, [[0, 6]]);
      }));
      function extendRegistration(_x14) {
        return _extendRegistration.apply(this, arguments);
      }
      return extendRegistration;
    }(),
    updateCustomer: function () {
      var _updateCustomer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee23(userData) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              _context23.next = 3;
              return amsResponse.getData({
                method: "POST",
                path: "v1.2/user/updatecustomer",
                contentType: amsResponse.contentTypes.json,
                body: stripEmptyValues(userData)
              });
            case 3:
              return _context23.abrupt("return", _context23.sent);
            case 6:
              _context23.prev = 6;
              _context23.t0 = _context23["catch"](0);
              if (!isCaptchaError(_context23.t0)) {
                _context23.next = 10;
                break;
              }
              throw newCaptchaRequiredError(_context23.t0);
            case 10:
              if (!isValidationError(_context23.t0)) {
                _context23.next = 12;
                break;
              }
              throw newValidationFailedError(_context23.t0);
            case 12:
              throw _context23.t0;
            case 13:
            case "end":
              return _context23.stop();
          }
        }, _callee23, null, [[0, 6]]);
      }));
      function updateCustomer(_x15) {
        return _updateCustomer.apply(this, arguments);
      }
      return updateCustomer;
    }(),
    updateUser: function () {
      var _updateUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee24(userData) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;
              _context24.next = 3;
              return amsResponse.getData({
                method: "POST",
                path: "v1.2/user/updateUser",
                contentType: amsResponse.contentTypes.json,
                body: userData
              });
            case 3:
              return _context24.abrupt("return", _context24.sent);
            case 6:
              _context24.prev = 6;
              _context24.t0 = _context24["catch"](0);
              if (!isCaptchaError(_context24.t0)) {
                _context24.next = 10;
                break;
              }
              throw newCaptchaRequiredError(_context24.t0);
            case 10:
              if (!isValidationError(_context24.t0)) {
                _context24.next = 12;
                break;
              }
              throw newValidationFailedError(_context24.t0);
            case 12:
              throw _context24.t0;
            case 13:
            case "end":
              return _context24.stop();
          }
        }, _callee24, null, [[0, 6]]);
      }));
      function updateUser(_x16) {
        return _updateUser.apply(this, arguments);
      }
      return updateUser;
    }(),
    getFormConfiguration: function () {
      var _getFormConfiguration = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_ref10) {
        var groupName, data;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              groupName = _ref10.groupName;
              _context25.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: urlPath(_templateObject || (_templateObject = _taggedTemplateLiteral(["v1.1/configuration/portalConfig/", ""])), groupName)
              });
            case 3:
              data = _context25.sent;
              return _context25.abrupt("return", data || []);
            case 5:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }));
      function getFormConfiguration(_x17) {
        return _getFormConfiguration.apply(this, arguments);
      }
      return getFormConfiguration;
    }()
  };
};